


var timerElement = document.getElementById('timer');
var timeLimitInMinutes = window.popup.daysUntil;
var timeLimitInSeconds = timeLimitInMinutes * 60;

function startTimer() {
  timeLimitInSeconds--;
  var minutes = Math.floor(timeLimitInSeconds / 60);
  var seconds = timeLimitInSeconds % 60;

  if (timeLimitInSeconds < 0) {
    // Reset the timer with a new time limit when it reaches zero
    timeLimitInMinutes = window.popup.daysUntil;
    timeLimitInSeconds = timeLimitInMinutes * 60;
  }

  if (timeLimitInSeconds < 0) {
    timerElement.textContent = '00:00';
    clearInterval(timerInterval);
    return;
  }

  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  timerElement.textContent = minutes + ':' + seconds;
}

var timerInterval = setInterval(startTimer, 1000);















